<script>
export default {
  props: {
    module: Object,
  },
  data: () => ({
    toggleButton: false,
    icon: 'el-icon-arrow-up',
    display: 'block',
  }),
  computed: {
    templateColumns() {
      return `repeat(${this.module.columns}, 60px)`
    },
    seatingArrangementMatrix(){
      let twoDimensionalArray = new Array(this.module.columns);
      for (let i = 0; i < twoDimensionalArray.length; i++) {
        twoDimensionalArray[i] = new Array(this.module.rows);
      }
      for (let i = 0; i < this.module.columns; i++) {
        for (let j = 0; j < this.module.rows; j++) {
          twoDimensionalArray[i][j] = this.setSetCell(i, j);
        }
      }
      return twoDimensionalArray;
    }
  },
  mounted() {
  },
  methods: {
    setSetCell(i, j) {
      return this.module.transport.find((x) => {
        return x.xCoord == i && x.yCoord == j
      });
    },
    toggle() {
      if (this.toggleButton) {
        this.icon = 'el-icon-arrow-down';
        this.display = 'none';
      } else {
        this.icon = 'el-icon-arrow-up';
        this.display = 'block';
      }
      this.toggleButton = !this.toggleButton;
    },
    ch(val, val1) {
      return `${val}-${val1}`;
    },
    ch1(val) {
      return `__${val}`;
    },

    classCell(item) {
      if (item != undefined)
        switch (item.type) {
          case 0:
            return '';
          case 1:
            return 'gray-cell';
          case 2:
            return 'red-cell';
          case 3:
            return 'green-cell';
          case 13:
            return 'green-light-cell';
          default:
            return '';
        }
      else return '';
    },
  },
};
</script>
<template>
  <div class="card-transport">
    <CardTitle>
      Tранспорт: {{module.transportName}}
    </CardTitle>
    <div
      v-if="module"
      class="p-t-c-ii"
      :style="{ display: display}"
    >
      <div>
        <div class="card-transport__legend">
          <div class="transport-legend__item">
            <div class="cell green-cell"><div class="cell-number"><span>1a</span></div><div class="cell-seating"></div></div>
            <div class="transport-legend__label">Свободно</div>
          </div>
          <div class="transport-legend__item">
            <div class="cell red-cell"><div class="cell-number"><span>2a</span></div><div class="cell-seating"></div></div>
            <div class="transport-legend__label">Заблокировано</div>
          </div>
          <div class="transport-legend__item">
            <div class="cell green-light-cell"><div class="cell-number"><span>3a</span></div><div class="cell-seating"></div></div>
            <div class="transport-legend__label">Выбрано</div>
          </div>
          <div class="transport-legend__item">
            <div class="cell gray-cell"><div class="cell-number"><span></span></div><div class="cell-seating"></div></div>
            <div class="transport-legend__label">Проход/Выход</div>
          </div>
        </div>
        <div class="card-transport__body" :style="{gridTemplateColumns: templateColumns}">
          <div v-for="(row, i) in seatingArrangementMatrix" :key="ch1(i)">
            <div class="cell" :class="classCell(col)" v-for="(col, j) in row" :key="ch(i,j)">
              <div class='cell-number'>
                <span>{{col.seatNumber}}</span>
              </div>
              <div class='cell-seating'></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#item_card_dialog_board {
  .card-transport {
    padding: 20px;
    background: #CFE3EE;
    width: 50%;

    .card-body {
      display: flex;
    }

    .card-title {
      margin: 0px;
      padding: 0px;
    }

    .card-title__btn {
      height: 0px;
    }

    .cell {
      border-radius: 7px;
      height: 40px;
      margin: 5px;
      width: calc(100% - 10px);

      &-number {
        display: flex;
      }

      &.active {
        border: 4px solid green;
      }

      &-seating {
        margin: 0;
        width: 40px;
        height: 7px;
        background: ghostwhite;
        border: 1px solid goldenrod;
      }

      &-number {
        width: 100%;
        height: 33px;
      }

      span {
        width: 100%;
        text-align: center;
        font-size: 12px;
        margin: auto;
      }

      &.green-cell {
        background: #67C23A;
        border-color: #67C23A;
        cursor: pointer;
      }

      &.gray-cell {
        border-radius: 0px;
        background: darkgray;
        border-color: darkgray;
        cursor: default;

        .cell-seating {
          background: none;
          border: none;
        }
      }

      &.green-light-cell {
        background: #FAB24C;
        border-color: #FAB24C;
        cursor: pointer;
      }

      &.red-cell {
        background: #F56C6C;
        border-color: #F56C6C;
        cursor: not-allowed;
      }
    }

    &__body {
      width: 100%;
      display: flex;
      justify-content: center;
    }

    &-container__selected {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      flex-wrap: wrap;

      div {
        height: auto;
        width: auto;
        margin: 10px;
        padding: 10px;
        background: #0c78ed;
      }
    }

    &__legend {
      display: flex;
      width: 100%;
      flex-direction: row;

      .cell {
        width: 40px;
      }
    }

    .transport-legend {
      &__item {
        display: flex;
        flex-direction: column;
        padding: 10px;
        width: 25%;
      }

      &__label {
        height: 24px;
        text-align: start;
        align-content: center;
      }
    }
  }

  &.mobile {
    .card-transport {
      .card-body {
        flex-direction: column;

      }

      &__legend {
        width: 100%;
        flex-direction: row;
        align-items: flex-start;
        flex-wrap: wrap;

        .cell {
          width: 30px;

          &-seating {
            width: 30px;
          }
        }

        .transport-legend__item {
          width: 50%;
        }

        .transport-legend__label {
          font-size: 12px;
        }
      }

      &__body {
        width: 100%;
      }

      &__selected {
        width: 100%;
        min-height: 40px;

        label {
          font-size: 12px;
        }
      }

      &-container__selected {
        div {
          margin: 5px;
          padding: 5px;
          background: #0c78ed;
          font-size: 12px;
        }
      }
    }
  }

  .el-loading-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 2000;
  }
}
</style>
